import React from 'react';

const BS_Quiz = () => {
    return (
        <div>
            <h1>BS_Quiz Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Quiz;
